import { makeStyles } from '@material-ui/styles';
import moment from 'moment';

type MonthDayCellProps = {
  label: string;
  date: Date;
};

const useStyles = makeStyles({
  dayLabel: { fontWeight: 400 },
  dayLabelToday: { fontWeight: 600 },
});

const MonthDayCell = ({ label, date }: MonthDayCellProps) => {
  const classes = useStyles();
  const isToday = moment(date).isSame(moment(), 'day');
  return (
    <span className={isToday ? classes.dayLabelToday : classes.dayLabel}>
      {label}
    </span>
  );
};

export default MonthDayCell;
